import React, { useEffect, useState } from "react";

const Rules = ({ data }: any) => {
  const [rulesData, setRulesData] = useState<any>([]);
  const [activeRules, setActiveRules] = useState(null);
  const [uniqueRules, setUniqueRules] = useState(new Set());
  const [filterdData, setFilteredData] = useState([]);

  const setRulesdata = (rules: any, data: any) => {
    const filteredData = data?.filter((item: any) => item?.Title === rules);

    setFilteredData(filteredData);
  };
  const getData = async () => {
    const rules = new Set();
    data?.forEach((item: any) => {
      const rulesName = item.Title;
      rules.add(rulesName);
    });
    setRulesData(data);
    setUniqueRules(rules);
    setActiveRules(data[0]?.Title);
    setRulesdata(rules.values().next().value, data);
  };

  useEffect(() => {
    getData();
  }, [data]);

  const handleRulesClick = (rules: any) => {
    setRulesdata(rules, rulesData);
    setActiveRules(rules);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            width: "90%",
          }}
        >
          {Array.from(uniqueRules).map((location: any, index) => (
            <>
              <div
                style={{
                  marginTop: "20px",
                  marginLeft: "1.5rem",
                  marginRight: "1.5rem",
                  marginBottom: "20px",
                  display: "flex",
                  boxSizing: "border-box",

                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontFamily: "Graphik,sans-serif",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    padding: "10px 24px",
                    height: "2.25rem",
                    borderRadius: "100px",
                    borderStyle: "solid",
                    borderColor:
                      activeRules === location ? "#3F41D1" : "#A3A3A3",
                    display: "flex",
                    alignItems: "center",
                    border:
                      activeRules === location
                        ? "1px solid #3F41D1"
                        : "1px solid #A3A3A3",
                    color: activeRules === location ? "#3F41D1" : "#666",
                    backgroundColor:
                      activeRules === location ? "#E1E8F5" : "#FFF",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleRulesClick(location);
                    setActiveRules(location);
                  }}
                  onMouseEnter={(e: any) => {
                    e.target.style.borderRadius = "100px";
                    e.target.style.border = "1px solid #3F41D1";
                    e.target.style.backgroundColor = "#E1E8F5";
                    e.target.style.color = "#3F41D1";
                  }}
                  onMouseLeave={(e: any) => {
                    if (activeRules !== location) {
                      e.target.style.borderRadius = "100px";
                      e.target.style.border = "1px solid #A3A3A3";
                      e.target.style.backgroundColor = "#FFF";
                      e.target.style.color = "#666";
                    }
                  }}
                >
                  {location}
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
      {filterdData.map((ruleData: any) => (
        <>
          <div
            id={ruleData.URL.split("id=")[1]}
            style={{
              display: "flex",
              backgroundColor: "var(--S4-Primary, #E1E8F5)",
              // opacity: "0.1",
              margin: "3rem auto",
              borderRadius: "20px",
              marginTop: "40px",
              width: "90%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                margin: "20px",
              }}
            >
              <div
                style={{
                  color: "var(--Text, #212121)",
                  // textAlign: "center",
                  fontFamily: "Graphik,sans-serif",
                  fontSize: "34px",
                  paddingBottom: "1rem",
                }}
              >
                {ruleData.Title}
              </div>
              <div
                style={{
                  color: "#000",
                  // textAlign: "center",
                  textAlign: "justify",
                  fontSize: "1.125rem",
                  overflow: "hidden",
                }}
                dangerouslySetInnerHTML={{
                  __html: ruleData.content || <div></div>,
                }}
              />
            </div>
          </div>
        </>
      ))}
    </>
  );
};

export default Rules;
